module.exports = __webpack_public_path__ + "static/icon_cerca_hinterland-f9b0a4c0f1a39313ecda32658ecc3108.svg";